import { jsx as _jsx } from "react/jsx-runtime";
import FinamIcon from './FinamIcon';
import { Root } from './Logo.styles';

var Logo = function Logo(_ref) {
  var variant = _ref.variant;
  var Icon;

  if (variant === 'finam') {
    Icon = FinamIcon;
  }

  if (!Icon) {
    return null;
  }

  return _jsx(Root, {
    children: _jsx(Icon, {})
  });
};

export default Logo;